import React, { useEffect, useState } from 'react'
import { getMallConfig } from 'common/config/mall'

export const useEnv = () => {
  const [isReady, setIsReady] = useState<boolean>(false)

  const setEnvironment = () => {
    const mallId = String(getMallConfig().id)
    localStorage.setItem('mall-id', mallId)
  }

  const getValidation = () => {
    const mallId = localStorage.getItem('mall-id')
    if (!mallId) return false
    return true
  }

  useEffect(() => {
    setEnvironment()
    setIsReady(getValidation())
    const handleStorageChange = () => {
      setIsReady(getValidation())
    }
    window.addEventListener('storage', handleStorageChange)
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  return { isReady }
}
